var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 28,
    viewBox: "0 0 51 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 50,
    height: 27,
    rx: 13.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 50,
    height: 27,
    rx: 13.5,
    stroke: "#3C81FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9258 20V12.5293H10.4399V10.9272H11.9258V10.0308C11.9258 9.42204 12.0282 8.91846 12.2329 8.52002C12.4432 8.12158 12.7669 7.82552 13.2041 7.63184C13.6413 7.43262 14.1947 7.33301 14.8643 7.33301C15.0856 7.33301 15.2904 7.34131 15.4785 7.35791C15.6667 7.36898 15.841 7.38835 16.0015 7.41602V8.86035C15.924 8.84928 15.8244 8.84098 15.7026 8.83545C15.5809 8.82438 15.4481 8.81885 15.3042 8.81885C14.8172 8.81885 14.4714 8.93229 14.2666 9.15918C14.0618 9.38053 13.9595 9.7098 13.9595 10.147V10.9272H15.9268V12.5293H13.9927V20H11.9258ZM17.662 20V7.41602H19.7288V20H17.662ZM24.9919 20.1826C24.3167 20.1826 23.7495 20.0526 23.2902 19.7925C22.8309 19.5269 22.485 19.1423 22.2526 18.6387C22.0202 18.1296 21.904 17.5153 21.904 16.7959V10.9272H23.9709V16.3228C23.9709 17.0256 24.1092 17.554 24.3859 17.9082C24.6626 18.2624 25.1136 18.4395 25.7389 18.4395C26.071 18.4395 26.3643 18.3896 26.6188 18.29C26.8789 18.1849 27.0947 18.0355 27.2663 17.8418C27.4378 17.6481 27.5679 17.4157 27.6564 17.1445C27.745 16.8678 27.7892 16.5579 27.7892 16.2148V10.9272H29.8561V20H27.7892V18.6221H27.6481C27.5098 18.943 27.3161 19.2225 27.0671 19.4604C26.818 19.6929 26.5192 19.8727 26.1706 20C25.822 20.1217 25.429 20.1826 24.9919 20.1826ZM31.3506 20L34.2891 15.501L31.3257 10.9272H33.708L35.5176 14.0732H35.6587L37.4517 10.9272H39.7178L36.7793 15.4097L39.751 20H37.4268L35.5674 16.8457H35.4263L33.5669 20H31.3506Z",
    fill: "#3C81FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeed);
export default __webpack_public_path__ + "static/media/feed.20706e2b97899215a0ad72c5eb392029.svg";
export { ForwardRef as ReactComponent };